import React, { useEffect, createContext, useState } from 'react';
import { useMemo } from 'react';

export const userAuth = createContext({});

const UserContextProvider = ({ children }) => {
	const [token, setToken] = useState({});
	const [reset, setReset] = useState(false);
	//
	useEffect(() => {
		const gettoken = JSON.parse(localStorage.getItem('user-auth'));
		if (gettoken) {
			setToken(gettoken);
		}
	}, []);

	const values = useMemo(
		() => ({
			token,
			setToken,
			reset,
			setReset,
		}),
		[token, reset],
	);
	return <userAuth.Provider value={values}>{children}</userAuth.Provider>;
};

export default UserContextProvider;
